import { render, staticRenderFns } from "./Evaluaciones.vue?vue&type=template&id=b2b28330&scoped=true"
import script from "./Evaluaciones.vue?vue&type=script&lang=js"
export * from "./Evaluaciones.vue?vue&type=script&lang=js"
import style1 from "./Evaluaciones.vue?vue&type=style&index=1&id=b2b28330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b28330",
  null
  
)

export default component.exports